import React, { useContext } from 'react';
import classNames from 'classnames';
import { StyleContext } from 'utils/context/StyleContextProvider';
import styles from './Share.module.scss';

export default function Share({ canonical, title }) {
    const parentStyles = useContext(StyleContext),
        processShareButtons = () => {
            const encodedURL = encodeURIComponent(canonical),
                encodedTitle = encodeURIComponent(title);

            return {
                facebook: {
                    tooltip: 'Share on Facebook',
                    img: 'https://images.ctfassets.net/qk4l4jfatr3e/5V22vjcOWf0gciZNgpL8zs/3feb9dc9d81b37396fea9ea7ba38e427/fill-1.svg',
                    url: `https://www.facebook.com/sharer.php?u=${encodedURL}`,
                },
                twitter: {
                    tooltip: 'Share on Twitter',
                    img: 'https://images.ctfassets.net/qk4l4jfatr3e/63zFPlgnQbjLKkDUaUdjR3/a7f63c2bd46c301d07e4a81b7c36273e/fill-9-copy.svg',
                    url: `https://twitter.com/intent/tweet?url=${encodedURL}&text=${encodedTitle}&via=Viome`,
                },
                linkedin: {
                    tooltip: 'Share on LinkedIn',
                    img: 'https://images.ctfassets.net/qk4l4jfatr3e/10xNyTaBpFdLj4ZDfkwzIN/4397e36e8f932c8e4e386d2a1402802b/streamline-icon-professional-network-linkedin-140-x-140_3x.png',
                    url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedURL}`,
                },
                email: {
                    tooltip: 'Share through Email',
                    img: 'https://images.ctfassets.net/qk4l4jfatr3e/1ddiiTZ63j45y7vcL06sd3/0310011edb3291ba80083f4bb61c6329/streamline-icon-email-action-unread-140-x-140_3x.png',
                    url: `mailto:?subject=${title}&body=${title}%20-%20${encodedURL}`,
                },
                hyperlink: {
                    tooltip: 'Copy URL',
                    img: 'https://images.ctfassets.net/qk4l4jfatr3e/2t4YZbBCQYHVniE7QTkFyW/48763bde14f1890afafc175a5abaed7b/streamline-icon-hyperlink-3-140-x-140_3x.png',
                },
            };
        },
        shareButtons = processShareButtons();

    return (
        <div className={classNames([styles.share, parentStyles?.share])}>
            <ul className="flex items-center gap-x-15">
                <li>
                    <p
                        className={classNames([
                            styles.label,
                            parentStyles?.label,
                        ])}
                    >
                        SHARE
                    </p>
                </li>
                {Object.keys(shareButtons).map((key) => {
                    const shareButton = shareButtons[key];
                    return (
                        <li key={key}>
                            <a
                                className={classNames(
                                    [styles.link, parentStyles?.link],
                                    styles[`link--${key}`],
                                    key,
                                )}
                                href={shareButton.url}
                                title={shareButton.tooltip}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={shareButton.img}
                                    alt={shareButton.tooltip}
                                    loading="lazy"
                                />
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
